import { FC } from 'react';
import { useIntl } from 'react-intl';

import { Icon, Tooltip } from '@/shared/ui';

import styles from './CoinBadge.module.scss';

type CoinBadgeProps = {
  className?: string;
  testID?: string;
};

export const CoinBadge: FC<CoinBadgeProps> = (props) => {
  const { className, testID } = props;

  const { formatMessage } = useIntl();

  return (
    <Tooltip.Primary
      triggerClassName={className}
      content={formatMessage({
        id: 'diagnocoins.badgeTooltip',
        defaultMessage: 'Pay with Diagnocoins',
      })}
    >
      <span data-testid={testID} className={styles.glyph}>
        <Icon name="cat" size={14} />
      </span>
    </Tooltip.Primary>
  );
};
